import { Component, Injector, OnInit } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { UntypedFormGroup } from '@angular/forms';
import { ApComplexModal } from 'webcommon/core-ui';
import {
  FindControlAdditionalSearchParametersDto,
  FindControlAdditionalSearchParametersType,
  FindControlDeleteItemResultDto,
  HiddenActionItemType,
  IColumnPk,
} from 'webcommon/shared';
import { ApFindControlService } from '../ap-findcontrol.service';

@Component({
  selector: 'fc-merge-item-modal',
  templateUrl: './fc-merge-item-modal.component.html',
})
export class FcMergeItemModalComponent extends ApComplexModal<FindControlDeleteItemResultDto> implements OnInit {

  findControlBehaviorId: string;
  findControlBehaviorName: string;
  primaryKeyColumnName: string;
  dataItem: IColumnPk;

  baseId = 'fc-merge-item-modal';
  fcMergeItemModalFormGroup = new UntypedFormGroup({});
  fcItemName = '';
  fcName = '';
  findControlDisplayName = '';
  hiddenActionItems: HiddenActionItemType[] = [];
  itemToExcludeAdditionalSearchParams: FindControlAdditionalSearchParametersDto | undefined;
  isSaving = false;
  newUid: string | null = '';

  constructor(
    elementInjector: Injector,
    private apFindControlService: ApFindControlService,
  ) {
    super(elementInjector);
  }

  override ngOnInit() {
    super.ngOnInit();

    this.fcName = this.findControlBehaviorName;
    this.fcItemName = this.dataItem.Name;
    this.findControlDisplayName = this.fcName + ': New Item';

    this.hiddenActionItems.push(HiddenActionItemType.Delete);
    this.hiddenActionItems.push(HiddenActionItemType.Modify);
    this.hiddenActionItems.push(HiddenActionItemType.New);

    this.itemToExcludeAdditionalSearchParams = {
      Type: FindControlAdditionalSearchParametersType.Standard,
      AdditionalSearchParameters:
      [
        {
          ColumnName: this.primaryKeyColumnName,
          Negate: true,
          Value: this.dataItem.Pk,
        },
      ],
    };
  }

  async onSave() {
    this.isSaving = false;

    if (this.fcMergeItemModalFormGroup.invalid) {
      return;
    }
    if (!this.newUid || this.newUid.length <= 0) {
      return;
    }
    if (this.newUid === this.dataItem.Pk) {
      return;
    }

    this.isSaving = true;

    const deleteItemResultDto = await this.apFindControlService.mergeItem(
      this.findControlBehaviorId, this.dataItem.Pk, this.newUid).toPromise();

    this.apClose(deleteItemResultDto);
  }

  onCancel() {
    super.apUserCancel();
  }
}
